import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';

import { AuthService } from './auth.service';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { FiltroUsuario } from '../_models/filtro-usuario';
import { CadastroUsuario } from '../_models/cadastro-usuario';
import { PoliticaPrivacidade } from 'app/_models/politica-privacidade';

@Injectable()
export class UsuarioService extends BaseService {

    headers: Headers;
    private endPoint = '/usuario';
    options: RequestOptions;

    constructor(
        private http: Http,
        private auth: AuthService, private httpClient: HttpClient) {
        super();
        this.headers = new Headers({ 'Content-Type': 'application/json' });
        this.options = new RequestOptions({ headers: this.headers });
    }

    public obterUsuarioPorId(usuarioId: string): Observable<CadastroUsuario> {
        return this.http
            .get(this.urlApi + this.endPoint + '/obter-por-id?usuarioId=' + usuarioId, this.auth.obterAuthHeader()).pipe(
                map(this.extractData),
                catchError(this.handleError)
            );
    }

    public obterUsuarioPorEmail(email: string): Observable<CadastroUsuario> {
        return this.http
            .get(this.urlApi + this.endPoint + '/obter-por-email?email=' + email, this.auth.obterAuthHeader()).pipe(
                map(this.extractData),
                catchError(this.handleError)
            );
    }

    public enviarEmailNovaSenha(email: string): Observable<CadastroUsuario> {
        return this.http
            .get(this.urlApi + this.endPoint + '/enviar-email-nova-senha?email=' + email, this.auth.obterAuthHeader()).pipe(
                map(this.extractData),
                catchError(this.handleError)
            );
    }

    obterUsuarios(filters: any, filtro: FiltroUsuario) {
        return this.http.post(`${this.urlApi}${this.endPoint}/todos` + filters, filtro, this.auth.obterAuthHeader()).pipe(
            map(this.extractData),
            catchError(this.handleError));
    }

    obterUsuariosSemFiltro() {
        return this.http.get(`${this.urlApi}${this.endPoint}/buscarTodos`, this.auth.obterAuthHeader()).pipe(
            map(this.extractArrayData),
            catchError(this.handleError));
    }

    obterUsuariosFiltrados(filters: any) {
        return this.http.get(`${this.urlApi}${this.endPoint}/filtrado` + filters, this.auth.obterAuthHeader()).pipe(
            map(this.extractData),
            catchError(this.handleError));
    }

    cadastrar(cadastroUsuario: CadastroUsuario) {
        return this.http
            .post(`${this.urlApi}${this.endPoint}` + '/cadastrar', cadastroUsuario, this.auth.obterAuthHeader()).pipe(
                map(this.extractData),
                catchError(this.handleError)
            );
    }

    atualizar(cadastroUsuario: CadastroUsuario) {
        return this.http
            .post(`${this.urlApi}${this.endPoint}` + '/atualizar', cadastroUsuario, this.auth.obterAuthHeader()).pipe(
                map(this.extractData),
                catchError(this.handleError)
            );
    }

    excluir(usuarioId: string) {
        return this.http
            .get(this.urlApi + this.endPoint + '/excluir?id=' + usuarioId, this.auth.obterAuthHeader()).pipe(
                catchError(this.handleError)
            );
    }

    checkarEmail(email: string) {
        return this.http.get(this.urlApi + this.endPoint + '/checar/' + email + '/email').
            catch(this.handleError);
    }

    aceitarPoliticaPrivacidade(politicaPrivacidade: PoliticaPrivacidade) {
        return this.http
            .post(`${this.urlApi}${this.endPoint}` + '/aceite-politica-privacidade', politicaPrivacidade, this.auth.obterAuthHeader()).pipe(
                map(this.extractData),
                catchError(this.handleError)
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/usuario.service.ts